import { useSyncExternalStore } from "react";

// https://react.dev/reference/react/useSyncExternalStore#adding-support-for-server-rendering
export function useHasMounted() {
  const hasMounted = useSyncExternalStore(
    () => () => null,
    () => typeof window !== "undefined",
    () => false
  );
  return hasMounted;
}
